// The human-readable task reference, in one place on the client.
//
// ⚠️ THIS EXISTED FIVE TIMES BEFORE THIS FILE. TodoList, TodoDetailModal and
// EmployeeHome each declared their own `formatTaskNumber`, BulkActionBar
// inlined the padStart, and the server formatted it by hand in four more places
// (see src/utils/command/taskRef.js, which is this file's twin).
//
// Duplication that produces the same string is only untidy. It stopped being
// untidy when the command bar started ACCEPTING these references as input:
// "TASK-0042 done" can only work if every screen shows the same reference the
// parser reads back, and five independent copies is five chances for one screen
// to drift and start displaying something nobody can type.
//
// Kept apart from lib/command.js on purpose — that module imports apiClient,
// and a task list should not pull in an axios instance to render a number.

const PAD = 4;

/** 42 → 'TASK-0042'. Null-safe: an unnumbered task gets a stable placeholder. */
export const formatTaskNumber = (n) => (
  n == null || Number.isNaN(Number(n)) ? 'TASK-????' : `TASK-${String(n).padStart(PAD, '0')}`
);

/** For a table cell that renders a whole task row rather than a bare number. */
export const taskRefOf = (task) => formatTaskNumber(task?.taskNumber);
